export default __webpack_public_path__ + "static/media/205.c93fe962.jpg";